export default {
  baseURL: "https://api.apartments.jarvis.oohdesk.ru",
  debug: false,
  analytics: {
    gtmId: "GTM-TCQB4RV"
  }
}
